import UserLogin from '@/views/auth/UserLogin.vue'

export default [
	{
		name: 'login',
		path: '/login',
		component: UserLogin,
		meta: { hideNav: true },
	},
]